export default "__VITE_ASSET__Ca6SBp1y__"